
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppModal extends Vue {
    @Prop({ default: true }) public showModal?: boolean

    @Emit('close')
    public onClickClose(e: Event) {
        return e
    }
}
